import React, { Fragment, useEffect, useState } from 'react';
import { Box, Flex } from "@chakra-ui/layout";
import socket from "../../utilities/socket";
import DrawingBoard from "react-drawing-board";
import { Operation } from "react-drawing-board/lib/SketchPad";
import { Container, Grid } from "@chakra-ui/react";
import { userType } from '../../interfaces/interfaces';

type Props = {
  peerId: string,
  callerVideo: userType
  participantVideo: userType & {sharing: JSX.Element[]},
  participantReceiverVideo: userType,
  sharing: JSX.Element | undefined
}

function VideoComponent({ peerId, callerVideo, participantVideo, participantReceiverVideo, sharing }: Props) {
  const [operations, setOperations] = useState<Operation[]>([]);
  const [boardOperations, setBoardOperations] = useState<Operation[]>([]);

  console.log(participantVideo.teacher)
  console.log(participantVideo.sharing)

  useEffect(() => {
    socket.on('boardData', (data) => {
      setBoardOperations(data)
    })
  })

  useEffect(() => {
    socket.emit("boardOperations", operations)
  }, [operations])

  return (
    <Flex mt={6} flexDirection={"column"} w={"100%"}>
      <Flex flexDirection={{ base: "column", lg: "row" }} justifyContent={"center"} flexWrap={"wrap"}>
        {callerVideo.teacher.length !== 0 && callerVideo.teacher.map((vid, index) => (
          <Fragment key={index}>
            {vid}
          </Fragment>
        ))}
        {participantVideo.teacher.length !== 0 && participantVideo.teacher.map((vid, index) => (
          <Fragment key={index}>
            {vid}
          </Fragment>
        ))}
        {participantVideo.sharing.length !== 0 && participantVideo.sharing.map((vid, index) => (
          <Fragment key={index}>
            {vid}
          </Fragment>
        ))}
        {participantReceiverVideo.teacher.length !== 0 && participantReceiverVideo.teacher.map((vid, index) => (
          <Fragment key={index}>
            {vid}
          </Fragment>
        ))}
        {sharing !== undefined && (sharing)}
        <Box boxShadow="2xl" order={2} w={{ base: "100%", lg: "40%" }} id={"sketch"} height={"inherit"}>
          <DrawingBoard
            userId={peerId}
            operations={boardOperations}
            onChange={(newOperation, afterOperation) => {
              console.log(`TODO: send ${newOperation}`);
              setOperations(afterOperation);
            }}
          />
        </Box>
      </Flex>
      <Container maxW="1000px" centerContent>
        <Grid gridTemplateColumns={"repeat(auto-fit, minmax(200px, 250px))"} justifyContent={"center"}
          w={"100%"} h={"250px"} mt={3} overflowX={"auto"}>
          {callerVideo.student.length !== 0 && callerVideo.student.map((vid, index) => (
            <Fragment key={index}>
              {vid}
            </Fragment>
          ))}
          {participantVideo.student.length !== 0 && participantVideo.student.map((vid, index) => (
            <Fragment key={index}>
              {vid}
            </Fragment>
          ))}
          {participantReceiverVideo.student.length !== 0 && participantReceiverVideo.student.map((vid, index) => (
            <Fragment key={index}>
              {vid}
            </Fragment>
          ))}
        </Grid>
      </Container>
    </Flex>
  );
}

export default VideoComponent;